var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const SmileyAlt = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M10.0001 9.5V10.5M14.0001 9.5V10.5M8.50006 14.188C8.50006 14.188 9.81206 15.5 12.0001 15.5C14.1881 15.5 15.5001 14.188 15.5001 14.188M12 2.5C6.75283 2.5 2.5 6.75283 2.5 12C2.5 17.2472 6.75283 21.5 12 21.5C17.2472 21.5 21.5 17.2472 21.5 12C21.5 6.75283 17.2472 2.5 12 2.5Z", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
